import { Injectable } from "@angular/core";
import { LuxonDateAdapter } from "@angular/material-luxon-adapter";
import { DateTime } from "luxon";

@Injectable()
export class CustomLuxonDateAdapter extends LuxonDateAdapter {
  override getDateNames(): string[] {
    // At the time of writing, Luxon doesn't offer similar
    // functionality so we have to fall back to the Intl API.
    const dtf = new Intl.DateTimeFormat('en-US', {day: 'numeric', timeZone: 'utc'});

    // Format a UTC date in order to avoid DST issues.
    return range(31, i => dtf.format(DateTime.utc(2017, 1, i + 1).toJSDate()));
  }
}

function range<T>(length: number, valueFunction: (index: number) => T): T[] {
  const valuesArray = Array(length);
  for (let i = 0; i < length; i++) {
    valuesArray[i] = valueFunction(i);
  }
  return valuesArray;
}
